import getLocalString from "constants/Localization";
import { useDeleteDailyFormWorkOrderMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteDailyFormWorkOrder() {
  const [mutation, { loading, error, data }] = useDeleteDailyFormWorkOrderMutation({
    refetchQueries: ["customGetDailyFormWorkOrders", "customGetVehicleDailyFormWorkOrders"],
  });

  const [deleteWorkOrder, context] = useBitumioMutation(
    {
      mutation,
      data,
      loading,
      error,
      key: "deleteDailyFormWorkOrder",
    },
    {
      successMessage: getLocalString("fleet.delete-work-order-success"),
      failureMessage: getLocalString("fleet.delete-work-order-failure"),
    }
  );

  return [deleteWorkOrder, context] as const;
}
